export default __webpack_public_path__ + "static/media/washing.95a79072.png";